<ion-accordion-group>
  @for (assignment of mappedAssignments; track assignment.assistantId) {
    <ion-accordion>
      <ion-item slot="header">
        <ion-label>{{ assignment.fullname }}</ion-label>
      </ion-item>
      <div slot="content">
        <app-tag-editor
          [ngModel]="getContent(assignment.assistantId)"
          (ngModelChange)="onContentChange(assignment.assistantId, $event)"
          [clientId]="currentClientId"
          [debug]="false"
          [placeholder]="'TAG_EDITOR.ENTER_NOTES_PLACEHOLDER' | transloco"
        ></app-tag-editor>
      </div>
    </ion-accordion>
  }
</ion-accordion-group>
